export default __webpack_public_path__ + "static/media/Notifications.e3a5c5d8.svg";